import { __rest } from 'tslib';
import React from 'react';
import { styled, Swiper, LazyImage } from '@teko/ui';
import { PreLoad } from '../PreLoad/PreLoad.es.js';
import { CustomLink } from '../CustomLink/CustomLink.es.js';

const Wrapper = styled.div `
  border-radius: 0.5rem;
  overflow: hidden;
`;
const MiniSlides = (_a) => {
    var { banners = [], isLoading = false, regionName, height = 140, width = 1232 } = _a, props = __rest(_a, ["banners", "isLoading", "regionName", "height", "width"]);
    if (isLoading)
        return React.createElement(PreLoad, { height: height, isLoading: isLoading });
    if (!isLoading && !banners.length)
        return null;
    return (React.createElement(Wrapper, Object.assign({}, props),
        React.createElement(Swiper, { autoplay: {
                delay: 2500,
            }, slidesPerView: 1, loop: true, hasNavigation: true }, banners.map((banner, index) => {
            return (React.createElement("div", { key: index, className: "swiper-slide", "data-track-content": true, "data-content-region-name": regionName || 'topBanner', "data-content-name": banner.campaignName, "data-content-index": index, "data-content-target": banner.targetPath },
                React.createElement(CustomLink, { targetPath: banner.targetPath },
                    React.createElement(LazyImage, { borderRadius: 8, height: height, src: banner.image, alt: banner.campaignName, width: width, imageWidth: width, hover: "zoom", cover: true }))));
        }))));
};

export { MiniSlides };
